module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_koyo-8e724cd1ee36c968c8cae402575eee8e.jpg";